let cached: boolean | null = null

/** True when the browser can create a WebGL (or WebGL2) canvas context. */
export function isLeafletWebGlAvailable(): boolean {
  if (cached !== null) return cached
  if (typeof document === 'undefined') {
    cached = false
    return cached
  }
  try {
    const canvas = document.createElement('canvas')
    const gl = (canvas.getContext('webgl2') ??
      canvas.getContext('webgl') ??
      canvas.getContext('experimental-webgl')) as WebGLRenderingContext | null
    if (!gl || typeof gl.createShader !== 'function' || typeof gl.drawArrays !== 'function') {
      cached = false
      return cached
    }
    // Prove shaders work — happy-dom / stubs often expose getContext but fail compile.
    const vs = gl.createShader(gl.VERTEX_SHADER)
    if (!vs) {
      cached = false
      return cached
    }
    gl.shaderSource(vs, 'attribute vec4 p; void main(){ gl_Position = p; }')
    gl.compileShader(vs)
    cached = gl.getShaderParameter(vs, gl.COMPILE_STATUS) === true
  } catch {
    cached = false
  }
  return cached
}

/** Test-only: reset the memoized WebGL probe. */
export function resetLeafletWebGlAvailabilityCache(): void {
  cached = null
}
